module.exports = __webpack_public_path__ + "static/banner-d57edd893c281975f0b6110deaeddd66.png";